import React, {FC} from 'react';
import {alpha, Typography} from '@mui/material';
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import {Theme, useTheme} from "@mui/material/styles";
import {SxProps} from "@mui/system";
import {WinnerEntry} from "../../../util/hooks/useWishCountdown";

interface IProps {
    entry: WinnerEntry | null;
    color: string;
    sx?: SxProps<Theme>;
}

const WinnerDisplay: FC<IProps> = ({entry, color, sx}) => {
    const theme = useTheme();

    if (!entry) return null;

    return (
        <Box p={1}>
            <Box sx={{
                background: alpha(theme.palette.primary.main, .2),
                backdropFilter: 'blur(5px)',
                py: 1,
                width: "100%",
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                position: "relative",
                textAlign: "center",
                ...sx
            }}>
                <Avatar
                    sx={{width: 56, height: 56, justifySelf: 'center', mt: 0.5}}
                    slotProps={{
                        img: {
                            loading: 'eager',
                            decoding: 'async',
                            fetchPriority: 'high'
                        }
                    }}
                    alt={entry.recipient_name ?? entry.full_name}
                    src={entry.recipient_name ? '' : entry.profile_picture}
                />
                <Typography variant="body1" sx={{color}} fontSize="1.5rem">
                    {entry.recipient_name ?? entry.full_name}
                </Typography>
                <Typography variant="body1" sx={{color}} fontSize="1rem">
                    {entry.code}
                </Typography>
            </Box>
        </Box>
    );
};

export default WinnerDisplay;
